// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c0b0f885","108":"5c8ba40a","229":"e15e79a7","446":"a983a653","482":"45759c52","755":"fec6e684","927":"18668ce3"}[chunkId] + ".chunk.css";
};